module.exports = __webpack_public_path__ + "static/media/011.91d3d0f6.jpg";